var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7410_634)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7410_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.5999C17.567 21.5999 22.0799 17.087 22.0799 11.5199C22.0799 5.95291 17.567 1.43994 11.9999 1.43994C6.43289 1.43994 1.91992 5.95291 1.91992 11.5199C1.91992 17.087 6.43289 21.5999 11.9999 21.5999Z",
    fill: "#996CFE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.2162 7.56116C14.3307 7.44672 14.4666 7.35596 14.6161 7.29399C14.7656 7.23207 14.9259 7.2002 15.0877 7.2002C15.2496 7.2002 15.4099 7.23207 15.5594 7.29399C15.7089 7.35596 15.8447 7.44672 15.9592 7.56116C16.0736 7.67564 16.1644 7.81147 16.2264 7.96099C16.2883 8.11051 16.3202 8.27079 16.3202 8.43264C16.3202 8.5945 16.2883 8.75477 16.2264 8.90429C16.1644 9.05381 16.0736 9.1897 15.9592 9.30413L10.0767 15.1866L7.68018 15.8402L8.33379 13.4437L14.2162 7.56116Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7410_634",
    x: -2.08008,
    y: -1.56006,
    width: 28.1602,
    height: 28.1602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7410_634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7410_634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7410_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditIcon);
export default __webpack_public_path__ + "static/media/profile-edit-icon.aae149cbe61ad34a0517f9a74d824011.svg";
export { ForwardRef as ReactComponent };